import {Component, Input, OnInit} from '@angular/core';
import {Job} from '../../../core/models';
import {generateTimeRange} from '../../utils/timeRangeGenerator.util';
import {JobsService} from '../../../core/services';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DialogService} from '../../../core/services/dialog.service';

export interface IAgendaJob {
  nextRunAt: string;
  repeatInterval: string;
}
@Component({
  selector: 'app-job-repost',
  templateUrl: './job-repost.component.html',
  styleUrls: ['./job-repost.component.css']
})
export class JobRepostComponent implements OnInit {
  @Input() job: Job;
  @Input() showRepostJob = false;
  timeRange = [];
  agendaJob: IAgendaJob;
  timeForm: FormGroup;
  loading = false;
  constructor(
    private jobsService: JobsService,
    private fb: FormBuilder,
    private dialogService: DialogService ) {
    this.timeForm = this.fb.group({
      day: ['', Validators.required],
      time: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.timeRange = generateTimeRange(1);
    this.getRepost();
  }

  getRepost() {
    this.jobsService.getRepost(this.job._id).subscribe( res => {
      this.agendaJob = res.success ? res.job : null;
      if (this.agendaJob) {
        this.setForm();
      }
    });
  }

  handleClick() {
    const options = {
      title: 'האם לבצע תזמון הקפצה?',
      message: 'בלחיצה על אישור, המשרה תוקפץ באופן קבוע',
      cancelText: 'ביטול',
      confirmText: 'אישור'
    };

    this.dialogService.open(options);

    this.dialogService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.createRepost();
      }
    });
  }

  createRepost() {
    this.loading = true;
    this.jobsService.createRepost(this.job._id, this.timeForm.value).subscribe( res => {
      this.loading = false;
      this.agendaJob = res.job;
      this.setForm();
    });
  }

  setForm() {
    const dayTypes = ['*/1', '*/2', '*/7'];
    const splitInterval = this.agendaJob.repeatInterval.split(' ');
    const hour = splitInterval[1].startsWith('0') ? splitInterval[1].charAt(1) : splitInterval[1];
    const time = splitInterval[0] + ' ' + hour;
    let day = splitInterval[2];
    if (dayTypes.indexOf(day) === -1) {
      day = dayTypes[0];
    }
    this.timeForm.get('day').setValue(day);
    this.timeForm.get('time').setValue(time);
  }

  clearSelect() {
    this.timeForm.reset();
  }

  cancelRepost() {
    const options = {
      title: 'האם לבטל תזמון הקפצה?',
      message: 'בלחיצה על אישור, תזמון הקפצת המשרה יבוטל',
      cancelText: 'ביטול',
      confirmText: 'אישור'
    };

    this.dialogService.open(options);

    this.dialogService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.jobsService.cancelRepost(this.job._id).subscribe( res => {
          this.agendaJob = null;
          this.timeForm.reset();
        });
      }
    });

  }

}
